import CryptoJS from 'crypto-js';
import { useContext } from 'react';
import { ModeProvider } from '../context/ModeContext';

const SECRET_KEY = 'mysecretkey'; 
export const encryptData =(value)=> {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    return encrypted;
}

export const decryptData = (value) => {
    const decrypted = CryptoJS.AES.decrypt(value, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
}